export const signupExperiences = {
  '<2': 'Moins de 2 ans',
  '2/5': '2 à 5 ans',
  '6/10': '6 à 10 ans',
  '10/100': 'Plus de 10 ans',
  none: 'Je débute dans le métier',
} as const;

export const experiences = {
  '<2': '0 à 2 ans',
  '2/4': '2 à 4 ans',
  '3/5': '3 à 5 ans',
  '5/8': '5 à 8 ans',
  '8/10': '8 à 10 ans',
  '>10': '> 10 ans',
} as const;

export const strategies = {
  solo: 'Je travaille principalement seul(e)',
  collaborating: "Je collabore déjà avec d'autres recruteurs",
  'want-to-collaborate': "J'aimerais commencer à collaborer avec d'autres recruteurs",
  'seeking-candidates': 'Je recherche surtout des candidats pour mes clients',
  'seeking-missions': 'Je recherche surtout des missions pour mes candidats',
} as const;

export const motivations = {
  'more-missions': 'Accéder à plus de missions',
  'share-candidates': 'Partager mes candidats non placés',
  'find-recruiters': 'Trouver des recruteurs de confiance pour déléguer du sourcing',
  'join-community': "M'intégrer dans une communauté dynamique de recruteurs indépendants",
  'improve-methods': 'Améliorer mon efficacité et mes méthodes',
  other: 'Autre',
} as const;

export const referrers = {
  member: 'Recommandé par un membre',
  linkedin: 'Via LinkedIn',
  event: 'Via un événement ou un webinaire',
  other: 'Autre',
} as const;

export const companySizes = {
  '1': '1 collaborateur·ice',
  '2/5': '2 à 5 collaborateur·ices',
  '6/10': '6 à 10 collaborateur·ices',
  '11/50': '11 à 50 collaborateur·ices',
  '>51': '> 51 collaborateur·ices',
} as const;

export const certifications = [
  { value: 'coaching', label: 'Coach' },
  { value: 'bilan-de-competence', label: 'Bilan de compétence' },
  { value: 'qualiopi', label: 'Qualiopi' },
];
